import React from 'react';

import Box from '../Box/Box';
import name from './name';

import InputError from '../InputError';

import TextFieldCharacterCountLabel from './TextFieldCharacterCountLabel';

type TTextFieldFooter = {
  helperText?: string;
  errorText?: string;
  charsRemainingText?: string;
  charsExceededText?: string;
  maxLength?: number;
  characterCount?: number;
  isFocused?: boolean;
  isRequired?: boolean;
};

const TextFieldFooter = ({
  errorText,
  maxLength = 0,
  characterCount = 0,
  isFocused,
  isRequired,
  charsExceededText,
  charsRemainingText,
}: TTextFieldFooter) => {
  const hasMaxLength = maxLength > 0;
  const isCharacterCountLabelVisible = hasMaxLength && (isRequired || isFocused || characterCount > maxLength);

  if (!isCharacterCountLabelVisible && !errorText) {
    return null;
  }

  return (
    <Box parent={name} name="footer" as="div">
      {isCharacterCountLabelVisible && (
        <TextFieldCharacterCountLabel
          characterCount={characterCount}
          charsRemainingText={charsRemainingText}
          charsExceededText={charsExceededText}
          maxLength={maxLength}
        />
      )}
      {errorText && <InputError errorText={errorText} />}
    </Box>
  );
};

export default TextFieldFooter;
